module.exports = __webpack_public_path__ + "static/obviouscheckout_thumbnail-5f27093708aa0827e5d8d80752c56fe0.jpg";